import { Component } from '@angular/core';
import { map } from 'rxjs/operators';

import { EntityType } from '@shared/components/audit/models/audit-log';
import { ContactEventService } from '@features/contacts/services/contact-event.service';

@Component({
  selector: 'app-trust-audit-list',
  templateUrl: './trust-audit-list.component.html'
})
export class TrustAuditListComponent {
  trustId$ = this.contactEventService.selectedContactInfo$.pipe(
    map(contactInfo => contactInfo.id)
  );
  entityType = EntityType.TRUST;

  constructor(private contactEventService: ContactEventService) {}
} 